/** Immutable View: a facility the caller can filter the costs by, with the structure it belongs to. */
class AiCostFacilityOptionView {
	readonly id: number;
	readonly label: string;
	readonly organizationId: number;

	constructor(payload: {
		readonly id: number;
		readonly label: string;
		readonly organization: { readonly id: number };
	}) {
		this.id = payload.id;
		this.label = payload.label;
		this.organizationId = payload.organization.id;

		Object.freeze(this);
	}
}

export default AiCostFacilityOptionView;
